export default 'Use arrow keys to select a saturation and brightness, on an x and y axis.';